import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";
import Image from "next/image";
import styles from "./SuccessStory.module.css";

const RegenesysAlumni = ({ data }: any) => {
  const { title_description, images } = data;

  return (
    <div>
      <div className={styles.container}>
        <h2 className={styles.title}>{title_description?.title}</h2>
        <p className={styles.paragraph}>{title_description?.description}</p>
      </div>
      <div className={styles.swiperWrapper}>
        <Swiper
          modules={[Autoplay]}
          slidesPerView={6}
          loop={true}
          speed={1200}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          allowTouchMove={false}
          breakpoints={{
            320: { slidesPerView: 3, spaceBetween: 5 },
            480: { slidesPerView: 3, spaceBetween: 8 },
            768: { slidesPerView: 3, spaceBetween: 5 },
            1024: { slidesPerView: 6, spaceBetween: 10 },
          }}
          style={{
            overflow: "hidden",
          }}
        >
          {images?.map((image: any) => (
            <SwiperSlide key={image?.id}>
              <div className={styles.imageWrapper}>
                <Image
                  src={image?.url}
                  alt={image?.alternativeText || "regenesys alumni"}
                  title={image?.alternativeText || "regenesys alumni"}
                  width={200}
                  height={60}
                  className={styles.image}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default RegenesysAlumni;
